import { jsxs as c, jsx as r } from "react/jsx-runtime";
import a from "classnames";
import f from "../../utils/colors.js";
import { Svg as l, Path as e } from "./Elements.js";
const p = "M4.691,0.874L4.691,2.655L0,2.655L0,4.412L14.091,4.412L14.091,2.655L9.41,2.655L9.41,0.874L4.691,0.874Z", u = "M7.511,12.359L9.397,12.359L9.397,7.94L7.511,7.94L7.511,12.359ZM4.706,12.356L6.567,12.356L6.567,7.948L4.706,7.948L4.706,12.356ZM1.875,5.294L1.875,13.613C1.875,14.378 2.536,15 3.348,15L10.741,15C11.553,15 12.214,14.378 12.214,13.613L12.214,5.294L1.875,5.294Z", v = ({
  className: L = "",
  clipRule: d = "evenodd",
  fill: t = f.blueGrey,
  fillRule: n = "evenodd",
  strokeLinejoin: m = "round",
  strokeMiterlimit: s = "2",
  viewBox: i = "0 0 15 15",
  focusable: o
}) => /* @__PURE__ */ c(
  l,
  {
    className: a({ [L]: !!L }),
    clipRule: d,
    fill: t,
    fillRule: n,
    strokeLinejoin: m,
    strokeMiterlimit: s,
    viewBox: i,
    focusable: !!o,
    "aria-hidden": !o,
    children: [
      /* @__PURE__ */ r(e, { d: p }),
      /* @__PURE__ */ r(e, { d: u })
    ]
  }
);
export {
  v as default
};
